import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";
import { IoIosLogOut, IoIosMenu } from "react-icons/io";
import { ROUTES } from "../routes/routes";
import { strings } from "../strings/strings";

const AdminHeader = ({ onMenuClick }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [superAdminData, setSuperAdminData] = useState(
    JSON.parse(localStorage.getItem("superAdmin")) || {},
  );
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const userInfo = {
    name:
      superAdminData?.firstName + " " + superAdminData?.lastName ||
      "Super Admin",
    email: superAdminData?.email || strings.NOT_ADDED,
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedData = JSON.parse(localStorage.getItem("superAdmin")) || {};
      setSuperAdminData(updatedData);
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    setIsDropdownOpen(false);
         localStorage.clear();
    navigate(ROUTES.WELCOME);
  };

  const handleProfileClick = () => {
    setIsDropdownOpen(false);
    navigate(ROUTES.ADMIN_PROFILE);
  };

  return (
    <header className="bg-white dark:bg-slate-800 px-4 sm:px-8 py-2 flex items-center justify-between border-b border-gray-200 dark:border-slate-700">
      <div className="flex items-center gap-2 sm:gap-4">
        {/* Mobile Menu Button */}
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
        >
          <IoIosMenu className="w-6 h-6 text-gray-600 dark:text-gray-300" />
        </button>

        <div>
          <h1 className="dark:text-white text-lg sm:text-2xl font-bold">
            {strings.SUPER_ADMIN_PANEL}
          </h1>
        </div>
      </div>

      <div className="flex items-center gap-2 sm:gap-3">

        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="flex items-center justify-center w-10 h-10 rounded-xl bg-slate-50 hover:bg-slate-100 ring-[6px] ring-slate-50/50 dark:bg-slate-800 dark:hover:bg-slate-700 dark:ring-slate-800/50 transition-all border border-slate-200 dark:border-slate-700"
          >
            <FaRegUser className="w-4 h-4 text-slate-500 dark:text-slate-400" />
          </button>

          {/* Dropdown Menu */}
          {isDropdownOpen && (
            <div className="absolute right-0 mt-2 w-56 sm:w-64 bg-white dark:bg-slate-800 rounded-lg shadow-lg border border-gray-200 dark:border-slate-700 py-2 z-50">
              <div className="px-4 py-3 border-b border-gray-200 dark:border-slate-700 sm:hidden">
                <p className="font-semibold text-sm text-gray-900 dark:text-white">
                  {userInfo.name}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  {strings.SUPER_ADMIN_ADMINISTER}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  {userInfo.email}
                </p>
              </div>

              {/* Menu Items */}
              <div className="py-2">
                <button
                  onClick={handleProfileClick}
                  className="w-full flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors"
                >
                  <FaRegUser className="w-4 h-4" />
                  <span>{strings.PROFILE}</span>
                </button>
              </div>

              {/* Logout */}
              <div className="border-t border-gray-200 dark:border-slate-700 pt-2">
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center gap-3 px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
                >
                  <IoIosLogOut className="w-4 h-4" />
                  <span>{strings.LOGOUT}</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
